import domReady from '@wordpress/dom-ready';
import { filter, isArguments, toArray } from 'lodash';

let $ = require( "jquery" );

domReady( function () {

    // Create elements storage
    // let filteredItems = document.createElement("div");
    // filteredItems.setAttribute("id", "filtered-items");
    // filteredItems.setAttribute("style", "display:none");
    // document.append(filteredItems);

    $(`.wp-block-query .hentry`).toArray().forEach((el, ind) => {

        $(el).attr('data-order', `${ind}`)
    })

    console.log($(`.wp-block-query .hentry`).data('order'))

    $("footer").append("<div id='filtered-items' style='display:none'></div>")

    let filteredItems = $("#filtered-items")

    let filters = $(".wp-block-spcomm-taxonomy-js-filter input[type=checkbox]");

    if ( filters.toArray().length ) {
        
        let taxonomy = $(".wp-block-spcomm-taxonomy-js-filter").attr('data-taxonomy');

        filters.toArray().forEach( (item, key, parent) => {

            // Get targeted filter
            let target = item.value;

            $(item).on('click', (event) => {
                
                // Transition on filtered items' parent
                let container = $(`.wp-block-query .grid.masonry`);

                $(container).addClass("transition");


                $(container).on('transitionend webkitTransitionEnd oTransitionEnd', function() {
                    

                    //Transition is over, remove class
                    $(container).removeClass('transition');
                    
                    // Get children elements
                    let elements = $(`.wp-block-query .hentry.${taxonomy}-${target}`);

                    
                    // Elements are not filtered
                    if (event.target.checked) {

                        $(filteredItems).children().toArray().forEach(el => {
                            if($(el).hasClass(`${taxonomy}-${target}`)) {
                                $(container).append(el)
                            }
                        })
                    }

                    // Elements are filtered
                    else {
                        $(elements).toArray().forEach(el => {
                            $(filteredItems).append(el)
                            console.log($(filteredItems).data('order'))
                        })

                    }

                });
                
            })
        })
    }

} );